import { Utensils, Users, ChefHat, BookOpen, Clock, MapPin } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const services = [
  {
    icon: Utensils,
    title: "Servicio de Restaurante",
    desc: "Servicio completo para comer en sala con atención personalizada y ambiente único.",
  },
  {
    icon: Users,
    title: "Espacio Familiar",
    desc: "Ambiente acogedor y cómodo para todas las edades. Ideal para reuniones familiares.",
  },
  {
    icon: ChefHat,
    title: "Cocina Casera Tradicional",
    desc: "Platos preparados con ingredientes frescos y las recetas de siempre.",
  },
  {
    icon: BookOpen,
    title: "Menú y Carta Completa",
    desc: "Menú variado del día y carta completa con platos para todos los gustos.",
  },
  {
    icon: Clock,
    title: "Horario Continuo",
    desc: "Abiertos todos los días con servicio continuo hasta las 22:00.",
  },
  {
    icon: MapPin,
    title: "Fácil Acceso",
    desc: "Ubicación céntrica en Ansoáin con fácil aparcamiento y acceso.",
  },
];

const ServicesSection = () => {
  const titleRef = useScrollAnimation();

  return (
    <section id="services" className="py-24 md:py-36 bg-[#0d0d0d]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header — asymmetric right-aligned */}
        <div ref={titleRef} className="fade-in-up mb-16 md:mb-24 text-right">
          <span className="text-gold text-xs tracking-[0.4em] uppercase font-body">Lo que ofrecemos</span>
          <div className="h-px w-12 bg-gold mt-3 mb-6 ml-auto" />
          <h2 className="font-heading text-4xl md:text-5xl text-[#ededed]">
            Nuestros <span className="italic text-gold-dark">Servicios</span>
          </h2>
        </div>

        {/* Grid — bento style */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#1c1c1c]">
          {services.map((service, i) => {
            const Icon = service.icon;
            return (
              <ServiceCard key={i} service={service} Icon={Icon} delay={i * 100} />
            );
          })}
        </div>
      </div>
    </section>
  );
};

const ServiceCard = ({ service, Icon, delay }) => {
  const ref = useScrollAnimation();

  return (
    <div
      ref={ref}
      className={`fade-in-up delay-${Math.min(delay, 500)} bg-[#0d0d0d] p-8 group hover:bg-[#121212] transition-all duration-300 border border-transparent hover:border-[rgba(212,175,55,0.2)]`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="mb-6">
        <div className="w-12 h-12 border border-[#262626] flex items-center justify-center group-hover:border-gold transition-colors duration-300">
          <Icon size={20} className="text-gold" />
        </div>
      </div>
      <h3 className="font-heading text-lg text-[#ededed] mb-3">{service.title}</h3>
      <p className="font-body text-[#a3a3a3] text-sm leading-relaxed">{service.desc}</p>
    </div>
  );
};

export default ServicesSection;
